import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import React from 'react';

const { Dragger } = Upload;

const FileUp = ({ file }) => (
  
  <Dragger>
    <p className="ant-upload-drag-icon">
      <InboxOutlined />
    </p>
    <p className="ant-upload-text">Click or drag file to this area to upload</p>
    <p className="ant-upload-hint">
      Support for a single or bulk upload. Upload your SOP here for review.
    </p>
    {/* Pass the file back to the parent component */}
    {file && (
      console.log(file),
      <p className="ant-upload-file-info">
        Uploaded File: {file.name} ({(file.size / 1024).toFixed(2)} KB)
      </p>
    )}
  </Dragger>
);

export default FileUp;
